import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { CpslButton, CpslIcon } from '@usecapsule/react-components';
import { ButtonWithIconContainer, Heading, SecondaryText } from '../common.js';
import { CAPSULE_CONNECT } from '../../constants/constants.js';
import { useThemeStore } from '../../stores/index.js';
export const Footer = ({ expandModal }) => {
    const isDark = useThemeStore(state => state.isDark);
    const handleConnectClick = () => {
        window.open(CAPSULE_CONNECT, '_blank');
    };
    return (_jsxs(_Fragment, { children: [_jsx(FooterContainer, { slot: "footer", children: _jsxs(FooterContentContainer, { children: [_jsxs(CondensedText, { children: ["Use this account across the web. ", _jsx(ClickableText, { onClick: expandModal, children: "Learn More." })] }), _jsxs(PoweredByContainer, { children: [_jsx(CondensedText, { children: _jsx("span", { children: "Powered by" }) }), _jsx(CapsuleLogo, { icon: "capsuleLogo" })] })] }) }), _jsxs(FooterContainer, { slot: "footerExpandedFooter", children: [_jsx(CapsuleIconContainer, { "$isDark": isDark, children: _jsx(LargeCapsuleIcon, { "$isDark": isDark, icon: "capsule" }) }), _jsxs(FooterContentContainer, { children: [_jsx(Heading, { children: "Your Capsule Wallet" }), _jsxs(FooterSecondaryText, { children: ["Experience all that Web3 has to offer without any of the confusion. You can use your Capsule wallet across all sorts of websites.", '\n\n', "Visit Capsule Connect to learn even more."] }), _jsx(ConnectButton, { onClick: handleConnectClick, children: _jsxs(ButtonWithIconContainer, { children: [_jsx(CapsuleIcon, { icon: "capsule" }), "Capsule Connect"] }) })] })] })] }));
};
const FooterContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0px 16px;
`;
const FooterContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const PoweredByContainer = styled.div `
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;
const CondensedText = styled(SecondaryText) `
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  display: inline-block;
`;
const FooterSecondaryText = styled(SecondaryText) `
  max-width: 315px;
`;
const ClickableText = styled(CondensedText) `
  color: var(--cpsl-color-text-primary);
  cursor: pointer;
  display: inline-block;
`;
const CapsuleLogo = styled(CpslIcon) `
  display: inline-block;
  --icon-color: var(--cpsl-color-text-secondary);
  --width: 65px;
  --height: auto;
`;
const CapsuleIcon = styled(CpslIcon) `
  --width: 20px;
  --height: 20px;
`;
const LargeCapsuleIcon = styled(CpslIcon) `
  --width: 23px;
  --height: 38px;

  --icon-color: ${({ $isDark }) => ($isDark ? 'black' : 'white')};
`;
const CapsuleIconContainer = styled.div `
  width: 80px;
  height: 80px;
  border-radius: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $isDark }) => ($isDark ? 'white' : 'black')};
`;
const ConnectButton = styled(CpslButton) `
  margin-top: 12px;
`;
